module.exports = __webpack_public_path__ + "static/media/safari-icon.d96dac6e.png";